export default [
    'ab',
    'aus',
    'außer',
    'bei',
    'mit',
    'nach',
    'seit',
    'von',
    'zu',
    'gegenüber'
];


/** WEBPACK FOOTER **
 ** ./app/components/pages/exercisePages/Prepositions/dativePrepositions.js
 **/